import httpService from "@/utils/services/http_service";

export default {
    /**
     * @author: liuxiangmin
     * date: 2020-03-02
     *  管理员列表
     */

    //  获取list
    async qaList(data={}) {
      return httpService.post(
        '/api.php?do=admin_sec_system_qa_list',
        data
      )
    },
    //  新增问答
    async qaCreate(data={}) {
      return httpService.post(
        '/api.php?do=admin_sec_system_qa_create',
        data
      )
    },
    //  更新问答
    async qaEdit(data={}) {
      return httpService.post(
        '/api.php?do=admin_sec_system_qa_edit',
        data
      )
    },
    //  删除问答
    async qaDelete(data={}) {
      return httpService.post(
        '/api.php?do=admin_sec_system_qa_delete',
        data
      )
    },
}